import { getFromLocalStorage } from "./helpers/localstorage";

export default function getUserPlugins(user) {
  const tenant = getFromLocalStorage("lefacWebTenant")?.data;
  const plugins = Object.keys(
    user.licence.tenants[tenant].plugins
  ).map((key) => ({ id: key, ...user.licence.tenants[tenant].plugins[key] }));
  return plugins;
}
